<template lang="pug">
  header.purchase-root
    transition(name="fade")
      .purchase-main(v-if="show")
        .purchase-logo 网易有道词典笔 2.0
        a.purchase-btn(:href="buyHref") 立即购买

</template>

<script>
export default {
  name: 'purchase',
  props: {
    buyHref: String,
    show: Boolean,
  },
}
</script>

<style scoped lang="stylus">
  .purchase-root
    position fixed
    top 0
    width 100%
    z-index 100
  .purchase-main
    background #f7f8fa
    height 1.3rem
    line-height @height
    transition all 0.3s ease
    text-align left
    width 100%
    padding 0 0.4rem
    box-sizing border-box
    font-size 0.44rem
  .purchase-logo
    display inline-block
    color #363a4f
    font-weight 500
  .purchase-btn
    float: right
    margin-top: 0.254rem
    border-radius 0.1rem
    background-color rgb(206, 40, 40)
    width 2rem
    line-height 0.8rem
    color #FFFFFF
    text-align center
    font-size 0.3rem
  .fade-enter-active, .fade-leave-active
    transition opacity .5s
  .fade-enter, .fade-leave-to
    opacity 0

</style>
